import React from "react";
import { useSelector, useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { PwaUpdater } from "pwa-updater";

import DocumentMeta from "react-document-meta";
import RequestForToken, {
  onMessageListener,
} from "./components/notification/firebase";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ErrorBoundary from "./components/common/ErrorHandler";
import Loading from "./components/layout/common/Loading";
import GetCustomerInf from "./components/api/customer/GetCustomerInf";
import NewBasket from "./components/api/customer/basket/NewBasket";
import RegisterVisit from "./components/api/visitor/RegisterVisit";
import AllProsApi from "./components/api/common/AllPros";
import DesignCatApi from "./components/api/common/DesignCat";
import AddLibrary from "./components/ui/jsLib";
import ScrollTop from "./components/helpers/ScrollTop";

import AppRoutes from "./components/routes";
import "bootstrap";

// redux seters
import { setAuth } from "./components/redux/reducers/customer";
import {
  setAllStates,
  setLocation,
  setRootDesignCats,
} from "./components/redux/reducers/page";
import { setVisitorInfo } from "./components/redux/reducers/visitor";

function App() {
  // redux hooks
  const { metaData } = useSelector((state) => state.page);
  const dispatch = useDispatch();

  // get dcode if exist
  const queryParams = new URLSearchParams(window.location.search);
  const dCode = queryParams.get("code") || "none";
  // react state hooks
  const [checked, setChecked] = React.useState(false);
  const [notifPermission, SendNotifPermission] = React.useState(false);

  // ساختن اطلاعات اولیه صفحه
  const inisializeLanding = async () => {
    // پیدا کردن استان ها
    const allStates = await AllProsApi();
    const theStates = allStates.data.map((state) => {
      return {
        id: state.id,
        cities: state.Cities,
        label: state.name,
      };
    });
    dispatch(setAllStates(theStates));

    // کنترل توکن مشتری
    const customerToken = Cookies.get("meshirtCustomer");
    if (customerToken && customerToken !== "undefined") {
      const customerResult = await GetCustomerInf(customerToken);
      if (customerResult) {
        Cookies.set("meshirtCustomer", customerResult.data.token, {
          expires: 365,
        });
        const besket = await NewBasket(customerResult.data.token);
        dispatch(
          setAuth({
            token: customerResult.data.token,
            customer: customerResult.data,
            isAuthenticated: true,
            newBasket: besket.data,
          })
        );
      }
    }

    const visitorToken = Cookies.get("meshirtVisitor");
    const customerResult = await RegisterVisit(
      customerToken,
      visitorToken,
      dCode
    );

    if (customerResult) {
      Cookies.set("meshirtVisitor", customerResult.data.cookieToken, {
        expires: 365,
      });
      dispatch(
        setVisitorInfo({
          token: customerResult.data.cookieToken,
          visitor: customerResult.data,
        })
      );
    }
    const designCats = await DesignCatApi(0);
    const rootDesignCats = designCats.data.map((designCat) => {
      return {
        id: designCat.id,
        title: designCat.title,
        description: designCat.description,
        mediaUrl: designCat.Media.mediaUrl,
      };
    });
    dispatch(setRootDesignCats(rootDesignCats));
    setChecked(true);
  };
  React.useEffect(() => {
    // دسترسی و گرفتن فایربیس توکن
    try {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          onMessageListener();
          SendNotifPermission(true);
        } else console.log("no permission to send Notification");
      });
    } catch (error) {
      // Safari doesn't return a promise for requestPermissions and it
      // throws a TypeError. It takes a callback as the first argument
      // instead.
      try {
        Notification.requestPermission().then((permission) => {
          if (permission === "granted") {
            onMessageListener();
            SendNotifPermission(true);
          } else console.log("no permission to send Notification");
        });
      } catch (error) {
        console.log(error);
      }
    } // گرفتن دسترسی و ست کردن موقعیت
    navigator.geolocation.getCurrentPosition(
      function (position) {
        dispatch(
          setLocation({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          })
        );

        // console.log("Latitude is :", position.coords.latitude);
        // console.log("Longitude is :", position.coords.longitude);
      }
      // function (error) {
      //   if (error.code === error.PERMISSION_DENIED)
      //     console.log("not accepted permission");
      // }
    );
    AddLibrary(process.env.REACT_APP_STATIC_DIR + "js/popper.js");
    AddLibrary(process.env.REACT_APP_STATIC_DIR + "js/bootstrap.js");
    AddLibrary(process.env.REACT_APP_STATIC_DIR + "js/custom.js");

    inisializeLanding();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ErrorBoundary>
      <PwaUpdater notify={true} />
      {notifPermission ? <RequestForToken /> : null}
      <DocumentMeta {...metaData}>
        <Loading />
        <ScrollTop>{checked ? <AppRoutes /> : null}</ScrollTop>
        <ToastContainer className="text-right" />
      </DocumentMeta>
    </ErrorBoundary>
  );
}

export default App;
